/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PrepareUserOpRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {PrepareUserOpResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const prepareUserOp = (request: PrepareUserOpRequest, options?: CashRequestOptions) => post<PrepareUserOpRequest, PrepareUserOpResponse>("/2.0/cash/prepare-user-op", request, {...options, rejectOnError: true })